export const GET_OFFER_LETTER_LIST="GET_OFFER_LETTER_LIST"
export const GET_OFFER_LETTER_LIST_SUCCESS="GET_OFFER_LETTER_LIST_SUCCESS"
export const GET_OFFER_LETTER_LIST_FAILED="GET_OFFER_LETTER_LIST_FAILED"